import React from 'react';
import Notifications from '../../containers/Notification/Notifications';

const NotificationsPage = () => {
  return <Notifications />;
};

export default NotificationsPage;
